import React from 'react';
import PropTypes from 'prop-types';

const CircularProgressBar = ({
  percentage = 0,
  color = '#75B084',
  size = 150,
  strokeWidth = 12,
}) => {
  const cx = size / 2;
  const cy = size / 2;
  // radius leaves room for the endpoint dot (16px radius + 3px half-stroke border)
  const R = size / 2 - 19;
  const circumference = 2 * Math.PI * R;
  const filled = (Math.min(Math.max(percentage, 0), 100) / 100) * circumference;
  const empty = circumference - filled;

  // Progress starts at bottom-center (6 o'clock = 90° in SVG coords).
  // Endpoint angle: 90 + percentage * 3.6 degrees
  const endAngleRad = ((90 + (percentage / 100) * 360) * Math.PI) / 180;
  const endX = cx + R * Math.cos(endAngleRad);
  const endY = cy + R * Math.sin(endAngleRad);

  const showDot = percentage > 0 && percentage <= 100;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Track */}
      <circle
        cx={cx} cy={cy} r={R}
        fill="none"
        stroke="#EFEFEF"
        strokeWidth={strokeWidth}
      />
      {/* Progress arc — rotated so stroke starts at bottom-center */}
      <circle
        cx={cx} cy={cy} r={R}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={`${filled} ${empty}`}
        strokeLinecap="round"
        transform={`rotate(90 ${cx} ${cy})`}
      />
      {/* Endpoint dot */}
      {showDot && (
        <circle
          cx={endX}
          cy={endY}
          r={16}
          fill={color}
          stroke="#FFFFFF"
          strokeWidth={6}
          filter='drop-shadow(0 0 1px rgba(0, 0, 0, 0.25))'
        />
      )}
      {/* Center labels */}
      <text
        x={cx}
        y={cy - 8}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="18"
        fontWeight="700"
        fontFamily="Lato, sans-serif"
        fill="#184A61"
      >
        {percentage}%
      </text>
      <text
        x={cx}
        y={cy + 12}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="12"
        fontFamily="Lato, sans-serif"
        fill="#184A61"
      >
        completed
      </text>
    </svg>
  );
};

CircularProgressBar.propTypes = {
  percentage: PropTypes.number,
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
};

export default CircularProgressBar;
